import React from 'react'
import inputComponents from './inputs/inputComponents'
import { checkConditionGroup, checkOperator, checkTextTranslation, checkTranslation, checkValueForFormVariables, getObject, setObject } from '../utils/useful'
// import TLink from './TLink'
// import ButtonAnimated from './buttons/ButtonAnimated'
import SwitchButton from './useful/SwitchButton'
import HelpButton from './HelpButton'

class FormViewer extends React.Component {
    state = {
        errors: {},
        data: {},
        valid: {},
        dependencies: {},
        currentPage: null,
        headers: [],
        lastPages: [],
        hiddenSections: {},
        width: this.props.width
    }

    componentDidMount() {
        // console.log("componentDidMountFormViewer", this.props.initData)
        this.init()
        window.addEventListener('resize', this.setFormWidth);
        this.setFormWidth()

        setTimeout(() => {
            this.setFormWidth()
        }, 100);

        setTimeout(() => {
            this.setFormWidth()
        }, 200);

        setTimeout(() => {
            this.setFormWidth()
        }, 300);

        setTimeout(() => {
            this.setFormWidth()
        }, 400);

    }

    componentWillUnmount() {
        window.removeEventListener('resize', this.setFormWidth)
    }

    componentDidUpdate(prevProps) {

        if ((JSON.stringify(this.props.initData) != JSON.stringify(prevProps.initData)) || (JSON.stringify(this.props.headers) !== JSON.stringify(prevProps.headers))) {
            this.init()
        }

        if (this.props.width != prevProps.width) {
            this.setFormWidth()
        }
    }



    checkDependencies = () => {

        this.state.dependencies = {}

        // console.log("checkDependencies")

        if (this.state.headers) {


            this.state.headers.forEach(header => {
                let hasDependency = (header.dependencies && header.dependencies.length > 0)



                if (hasDependency) {
                    let dependencies = this.state.dependencies


                    header.dependencies.forEach(dependency => {


                        let newDependency = JSON.parse(JSON.stringify(dependency))
                        newDependency.target = header.key

                        if (Array.isArray(dependency.refKey)) {
                            let refkeis = dependency.refKey
                            refkeis.forEach(refkeyi => {
                                if (!dependencies[refkeyi]) {
                                    dependencies[refkeyi] = []
                                }

                                dependencies[refkeyi].push(newDependency)

                            })
                        } else {
                            if (!dependencies[dependency.refKey]) {
                                dependencies[dependency.refKey] = []
                            }

                            dependencies[dependency.refKey].push(newDependency)
                        }

                        this.state.dependencies = dependencies
                        // console.log(dependencies)

                    })
                }
            })

            if (this.state.data) {

                let doInit = {}
                this.props.headers.forEach(prop => {
                    this.changeDependency(prop.key, this.state.data[prop.key], true, doInit)
                })
                this.changeDependency('_id', this.state.data["_id"], true, doInit)

                this.changeDependency('*', null, true, doInit)


                let doEffectKeys = Object.keys(doInit)
                if (doEffectKeys.length > 0) {

                    for (let d = 0; d < doEffectKeys.length; d++) {
                        const doEffectKey = doEffectKeys[d];

                        if (this["component-" + doEffectKey] && this["component-" + doEffectKey].init) {
                            // console.log("doEffectKey", doEffectKey)
                            this["component-" + doEffectKey].init()
                        }
                    }

                }

            }
        }
    }



    changeDependency(key, value, init, doInit) {
        let dependencies = this.state.dependencies

        // console.log("changeDependency key,", key)

        // console.log(dependencies)

        if (dependencies[key]) {




            // let doInit = {}

            dependencies[key].forEach(dependency => {

                let isEffected = false
                let conditions = dependency.conditions
                if (!Array.isArray(conditions)) {
                    conditions = [conditions]
                }

                conditions.forEach(condition => {
                    this.goForCondition(dependency, condition, (effected) => {
                        if (effected) {
                            isEffected = true

                            if (dependency.init != null) {
                                if (doInit) {
                                    doInit[dependency.targetKey] = true
                                } else {

                                    if (dependency.init != null) {
                                        if (this["component-" + dependency.targetKey] && this["component-" + dependency.targetKey].init) {
                                            this["component-" + dependency.targetKey].init()
                                        }
                                    }
                                }
                            }
                        }
                    })
                })



                // console.log("dependency", dependency)
                // console.log("isEffected", isEffected)
                // console.log("this.state.data",this.state.data)
                // console.log("changeDependency")

                // console.log("dependency",isEffected, dependency)

                if (!isEffected) {

                    // console.log("!isEffected")
                    let headers = this.state.headers
                    let variables = { data: this.state.data }


                    if (dependency.else) {
                        // console.log("dependency.else")

                        this.doEffect(dependency, dependency.else, variables, true)

                    } else {
                        if (dependency.show != null) {
                            headers.forEach(header => {
                                if (dependency.targetKey == header.key) {
                                    header.hideComponent = dependency.show
                                }
                            });
                        }


                        if (dependency.disabled != null) {
                            headers.forEach(header => {
                                if (dependency.targetKey == header.key) {
                                    header.information.disabled = dependency.disabled
                                }
                            });
                            // this.setState({ headers })
                        }

                        this.setState({ headers })


                    }
                }

            });



            this.setState({ dependencies })

        }
    }

    goForCondition(dependency, condition, cb) {
        // let condition = dependencies.condition
        let variables = { data: this.state.data }
        let result = checkConditionGroup(condition.root, variables)

        // if (dependency.targetKey == 'view.settings.stacked.date') {
        //     console.log("dependency", dependency)
        //     console.log(variables)
        // console.log(result)

        // }
        // console.log("condition",condition)
        // console.log("result",result)

        if (result) {


            let effect = condition.effect ?? dependency

            // console.log("EFFECT",effect,)

            this.doEffect(dependency, effect, variables, result)
        }


        cb(result)

    }


    doEffect(dependency, effect, variables, result) {

        let headers = this.state.headers

        if (effect.show != null) {
            headers.forEach(header => {
                if (dependency.targetKey == header.key) {
                    // console.log("Hide",result ? !effect.show : effect.show)
                    // console.log("effect",effect)

                    header.hideComponent = result ? !effect.show : effect.show
                }
            });
            // this.setState({ headers })
        }

        if (effect.disabled != null) {


            // console.log(effect)

            headers.forEach(header => {
                if (dependency.targetKey == header.key) {

                    // console.log(dependency.targetKey,effect.disabled)
                    header.information.disabled = effect.disabled
                }
            });
        }

        if (effect?.changeValue != null) {
            let data = this.state.data
            setObject(data, dependency.targetKey, getObject(data, dependency.refKey))
            // data[dependency.targetKey] = data[dependency.refKey]
            this.setState({ data })
        }


        let changeHeaders = effect?.changeHeader

        if (changeHeaders != null) {

            if (!Array.isArray(changeHeaders)) {
                changeHeaders = [changeHeaders]
            }

            changeHeaders.forEach(changeHeader => {
                headers.forEach(header => {
                    if (dependency.targetKey == header.key) {
                        // console.log(checkValueForFormVariables(dependency.changeHeader.value, variables))
                        // console.log(dependency.changeHeader.value)
                        // console.log(variables)
                        let newValue = checkValueForFormVariables(changeHeader.value, variables)
                        // console.log(newValue)
                        if (changeHeader?.converts) {
                            newValue = this.convertObject(newValue, changeHeader?.converts)
                        }
                        setObject(header, changeHeader.key, newValue)
                    }
                })

            })
            // this.setState({ headers })
        }



        let changeData = effect?.changeData

        if (changeData != null) {

            if (!Array.isArray(changeData)) {
                changeData = [changeData]
            }

            let data = this.state.data
            changeData.forEach(myChangeData => {

                setObject(data, myChangeData.key, myChangeData.value)

            })
            this.setState({ data })
        }

        this.setState({ headers })

    }


    convertObject = (object, convert) => {
        let newObject

        if (Array.isArray(object)) {

            newObject = []
            object.forEach(oneInArray => {
                let tempNewObject = this.convertOneOfObject(oneInArray, convert)
                newObject.push(tempNewObject)
            });
        } else {
            newObject = this.convertOneOfObject(object, convert)
        }
        // console.log("return")
        return newObject

    }

    convertOneOfObject(object, convert) {
        let newObject = { ...object }
        convert.forEach(oneConvert => {
            newObject[oneConvert.targetKey] = newObject[oneConvert.valueKey]
        })

        // convert.forEach(oneConvert => {
        //     delete newObject[oneConvert.valueKey]
        // })


        return newObject
    }


    // checkConditionGroup = (group, variables) => {
    //     let result = false
    //     if (group.action && group.action == 'and') {
    //         result = true
    //     }
    //     for (const [key, value] of Object.entries(group.conditions)) {
    //         if (this.checkOneCondition(value, variables) != result) {
    //             return !result
    //         }
    //     }

    //     return result
    // }




    // checkOneCondition = (condition, variables) => {
    //     let action = condition.action
    //     if (action) {
    //         return checkConditionGroup(condition, variables)
    //     } else {
    //         // source operator target
    //         let source = checkValueForFormVariables(condition.source.value, variables)
    //         let operator = condition.operator.value
    //         let target = checkValueForFormVariables(condition.target.value, variables)

    //         return checkOperator(source, operator, target)

    //     }
    // }





    // checkValueForVariables = (value, variables) => {
    //     let newValue = value

    //     if (typeof newValue == "string") {
    //         newValue = value.split(' ')

    //         for (let i = 0; i < newValue.length; i++) {
    //             const element = newValue[i]
    //             if (element.startsWith('@')) {
    //                 // console.log(this.getValueOfVariable(element, variables))
    //                 newValue[i] = this.getValueOfVariable(element, variables)
    //             }
    //         }
    //         if (newValue.length > 1) {
    //             newValue = newValue.join(' ')
    //         } else {
    //             newValue = newValue[0]
    //         }
    //     }

    //     return newValue

    // }

    // getValueOfVariable(element, variables) {
    //     // console.log(element)
    //     let key = element.substring(1)
    //     key = key.split('.')
    //     let variableSource = key[0]
    //     key.splice(0, 1)
    //     key = key.join('.')

    //     return getObject(variables[variableSource], key)
    // }



    getForm = () => {

        if (this.validator(this.state.headers, this.state.data).valid) {
            return this.state.data ? this.state.data : {}
        } else {
            return null
        }
    }



    init = (currentPage) => {
        // console.log("***init", this.props.headers)
        // console.log("***init", this.props.initData)

        this.setFormWidth()

        if (this.props.headers) {
            let headers = JSON.parse(JSON.stringify(this.props.headers))
            let visibleHeaders = []

            if (this.props.pages && this.props?.pages.length > 0) {
                currentPage = currentPage ?? this.props.pages[0]
                headers.forEach(header => {
                    if (!header.section && !currentPage.sections) {
                        // header.hideComponent = true
                        visibleHeaders.push(header)

                    } else {
                        // if (!header.pages || header.pages.includes(currentPage.key)) {
                        if (Array.isArray(currentPage.sections)) {

                            for (let s = 0; s < currentPage.sections.length; s++) {
                                const section = currentPage.sections[s];

                                if (header.section == section.key) {
                                    visibleHeaders.push(header)
                                }
                            }


                        }

                    }
                });

                if (this.props.setFormStatus) {
                    this.props.setFormStatus('hasNext', !currentPage.isLastPage)
                }
            } else {
                visibleHeaders = headers
                if (this.props.setFormStatus) {
                    this.props.setFormStatus('hasNext', false)
                }

            }
            // console.log(this.props.pages)
            // console.log(this.props.initData)

            let params
            if (this.props.params) {
                params = JSON.parse(JSON.stringify(this.props.params))
            }

            this.setState({ show: true, headers: visibleHeaders, currentPage, params: params }, () => {
                this.makeInitValue({ ...this.props.initData }, () => {

                    if (this.props.setFormStatus) {
                        let isValid = this.validator(this.state.headers, this.state.data, true).valid
                        this.props.setFormStatus("canSubmit", isValid)
                        this.props.setFormStatus("hasBack", (this.state.lastPages?.length > 0))

                    }
                })

            })
        }

        // setTimeout(() => {
        //     this.setFormWidth()   
        // }, 500);
    }


    nextPage = (page) => {

        let isValid = this.validator(this.state.headers, this.state.data).valid


        if (isValid) {
            let currentPage = this.state.currentPage
            let lastPages = this.state.lastPages
            if (currentPage) {
                lastPages.push(currentPage)
            }
            let pages = this.props.pages


            if (currentPage.changeConditions) {

                let variables = { data: this.state.data }
                let nextPageKey

                currentPage.changeConditions.forEach((changeCondition, index) => {

                    let result = checkConditionGroup(changeCondition.conditions.root, variables)
                    // console.log(result)
                    // console.log(changeCondition)

                    if (result) {
                        nextPageKey = changeCondition.nextPage
                    }
                });

                // console.log(nextPageKey)

                if (nextPageKey) {
                    pages.forEach((page, index) => {
                        if (page.key == nextPageKey) {
                            currentPage = page
                        }
                    });
                } else {
                    currentPage = null
                }


            } else {


                let currentPageIndex

                pages.forEach((page, index) => {
                    if (page.key == currentPage.key) {
                        currentPageIndex = index
                    }
                });

                if (pages[currentPageIndex + 1]) {
                    currentPage = pages[currentPageIndex + 1]
                }

            }

            // this.props.setFormStatus('hasNext', !currentPage.isLastPage)
            // console.log(currentPage)
            if (currentPage) {
                this.setState({ show: false, currentPage, lastPages }, () => {
                    if (this.props.scrollToTop) {
                        this.props.scrollToTop()
                    }
                    this.init(currentPage)
                })
            }
        }

    }



    backPage = (cb) => {

        let lastPages = this.state.lastPages

        let page = lastPages[lastPages.length - 1]
        if (page !== null) {
            lastPages.pop()
            this.setState({ currentPage: page, lastPages }, () => {
                if (this.props.scrollToTop) {
                    this.props.scrollToTop()
                }
                this.init(page)
            })
        }
    }



    clearForm = () => {
        this.setState({ data: {} })
    }


    validator(headers, data, dontSetErrors) {

        let valid = true
        let errors = {}

        // console.log(data)
        headers.forEach(header => {



            if (header.information?.required && !header.hideComponent) {

                let value = getObject(data, header.key)

                if (header.type == 'ImageInput' || header.type == 'FileInput' || header.type == 'ImageProfileInput') {

                    if (!value || value === '') {
                        value = getObject(data, ('**files.' + header.key), 1)
                    }
                    if (!value || value === '') {
                        valid = false
                        errors[header.key] = '{{lang}}errors.required-field'
                    }
                } else {
                    // let value = getObject(data, header.key)
                    if (value == null || value === '') {
                        valid = false
                        errors[header.key] = '{{lang}}errors.required-field'
                    }
                }

                if (header.type == 'PhoneInput') {
                    // let value = getObject(this.state.data, header.key)
                    if (!value || value.length < 6) {
                        valid = false
                        errors[header.key] = '{{lang}}errors.required-field'
                    }
                }

                if (header.type == 'SubformInput') {
                    if (!value || value.length < 1) {
                        valid = false
                        errors[header.key] = '{{lang}}errors.required-field'
                    } else {
                        value.forEach(subValue => {
                            // header.information.headers.forEach(subHeader => {
                            // console.log(subHeader)
                            let validator = this.validator(header.information.headers, subValue)
                            if (!validator.valid) {
                                valid = false
                                // console.log(validator)
                                errors[header.key] = '{{lang}}errors.required-field'

                                // errors[header.key] = validator.errors
                            }
                            // });
                        });
                    }
                }

                if (header.type == 'AddressInput') {
                    let formData = this["component-" + header.key].getForm()
                    if (!formData) {
                        valid = false
                        // errors[header.key] = '{{lang}}errors.required-field'
                    }
                }
            }
        })
        if (!dontSetErrors) {
            this.setState({ errors })
        }
        return { valid, errors }
    }




    makeInitValue(rawData, cb) {
        // console.log('hereeeeeeeeeeeeeeeeeeeeeeeS', );
        // let newData = {}
        // this.setState({ data: newData, show: false }, () => {
        //     if (data) {
        //         for (const [key, value] of Object.entries(data)) {
        //             this.state.headers.forEach(header => {
        //                 if (header.key === key) {
        //                     newData[key] = value
        //                 }
        //             });
        //         }
        //     }

        let data = rawData
        if (data == null) {
            data = {}
        }
        this.state.headers.forEach(header => {
            if (getObject(data, header.key) == null && header.information?.default != null) {
                // data[header.key] = header.information?.default
                setObject(data, header.key, header.information?.default)
            }

            if (getObject(data, header.key) == null && header.information?.defaultValue != null) {
                // data[header.key] = header.information?.defaultValue
                setObject(data, header.key, header.information?.defaultValue)

            }
        });

        // console.log(data)
        if (this.state.data) {
            let stateData = JSON.parse(JSON.stringify(this.state.data))
            if (stateData.values && data.values) {
                data.values = { ...data.values, ...stateData.values }; // or use a deep merge function
                stateData.values = JSON.parse(JSON.stringify(data)).values // or use a deep merge function
            }
            data = { ...data, ...stateData }
        }

        // console.log('hereeeeeeeeeeeeeeeeeeeeeeeS', data)



        this.setState({ data: data, show: true }, () => {
            this.setFormWidth()
            this.checkDependencies()
            if (this.props.liveChange) {
                this.props.liveChange({ ...data }, true, null, null, this.props.extra)
            }

            if (cb) {
                cb()
            }
            // console.log("this is data", this.state.data)

        })
    }

    setFormWidth = () => {
        if (this.form) {
            this.setState({ width: this.form.getBoundingClientRect().width }, () => {
                // console.log(this.state.width)
            })
        }
    }

    changeFiles = (value, key, extra) => {
        let data = this.state.data ?? {}

        if (data['**files'] == null) {
            data['**files'] = {}
        }
        if (value) {
            value.formType = ''
        }

        this.state.headers.forEach(header => {
            if (value && header.key == key) {
                value.formType = header.type
                // value.single = header.information?.single
            }
        });

        data['**files'][key] = value
        // console.log(data)
        this.setState({ data })
    }

    changeValue = (key, value, extra, full, dontUpdate, cb) => {

        let data = { ...this.state.data }

        data = setObject(data, key, value, extra?.append, null, true)

        // console.log("data",data)

        this.setState({ data }, () => {
            this.changeDependency(key, value)
            if (this.props.liveChange && !dontUpdate) {
                this.props.liveChange(data, false, key, value, extra, full)
            }

            if (this.props.setFormStatus) {
                // if (this.validator(this.state.headers, this.state.data).valid) {
                let isValid = this.validator(this.state.headers, this.state.data, true).valid
                this.props.setFormStatus("canSubmit", isValid)
                // }
            }
            if (cb) {
                cb()
            }
            // }
            // } else {

            //     console.log("dontUpdate")
            //     this.state.data = data
            // }

        })


        let params = this.state.params

        if (Array.isArray(params)) {
            for (let i = 0; i < params.length; i++) {
                let param = params[i];
                if (param.value == '*record') {
                    param.info = data
                }
            }
        }

    }


    // setError = (key, value) => {
    //     let errors = this.state.errors
    //     errors[key] = value
    //     this.setState({ errors })

    // }

    // setValid = (key, value) => {
    //     let valid = this.state.valid
    //     valid[key] = value
    //     this.setState({ valid })
    // }


    setStatus = (type, key, value) => {
        let errors = this.state.errors
        let valid = this.state.valid


        delete errors[key]
        delete valid[key]

        if (type == 'error') {
            errors[key] = value
        }
        if (type == 'valid') {
            valid[key] = value
        }

        this.setState({ errors, valid })

        if (this.props.liveChange) {
            this.props.liveChange(this.state.data, false, key, value, null, valid)
        }

    }



    formColBuilder(col) {
        let finalCol = 'col-12'

        // console.log(this.state.width)
        if (500 < this.state.width && col) {
            finalCol = 'col-' + col
        }
        if (this.props.col) {
            finalCol = 'col-' + this.props.col
        }

        finalCol = " " + finalCol + " "

        return finalCol
    }

    changeTab = (section) => {

        this.setState({ currentTab: section })
    }

    toggleSection = (section) => {
        let hiddenSections = this.state.hiddenSections ?? {}
        if (hiddenSections[section.key]) {
            delete hiddenSections[section.key]
        } else {
            hiddenSections[section.key] = true
        }

        this.setState({ hiddenSections })
    }

    changeInputDisabledStatus = (key, status) => {
        let headers = this.state.headers
        // console.log(key, status)
        headers.forEach(header => {
            if (header.key == key) {
                // console.log('key',key)
                header.information.disabled = !status
                // console.log('header',header)
            }
        });

        // console.log('changeInputDisabledStatus', headers)
        this.setState({ headers }, () => {
            // console.log('this.props.setData', this.props)
            if (this.props.setData) {
                // console.log(true, 'data')
                this.props.setData('headers', this.state.headers)
            }
        })
    }



    renderSection(headers) {

        // console.log("this.state.data",this.state.data)

        return (
            <section className={"w-100 form " + (this.props.formClass ?? 'dafault-form')} ref={(el) => this.form = el}>

                <div className="row m-0 ">
                    {headers && headers.map((header, index) => {
                        let Component = inputComponents[header.type]
                        let data = getObject(this.state.data, header.key)//this.state.data[header.key] ? this.state.data[header.key] : ''
                        //    console.log(header.key,data)
                        //    console.log(this.state.data)

                        let files
                        if (this.state.data && this.state.data['**files']) {
                            files = getObject(this.state.data['**files'], header.key)//this.state.data[header.key] ? this.state.data[header.key] : ''
                        }

                        let information = header.information

                        if (header.section && this.state.hiddenSections[header.section]) {
                            return
                        }
                        // console.log(header)
                        // console.log(header.key)

                        // console.log(data)
                        // console.log(this.state.data)

                        // console.log(header.information?.default)

                        if (data == null && header.information?.default != null) {
                            // console.log(header.information?.default)

                            data = header.information?.default
                        }

                        if (header.type == 'SectionIndicator') {
                            return (
                                <div key={header.key} onClick={() => this.toggleSection(header)} className="col-12 mb-3 mt-2 text-start SectionIndicator  cursor-pointer" >
                                    <div className={'flexcb w-100  ' + (this.state.hiddenSections[header.key] ? 'pb-3' : '')} style={{ borderBottom: this.state.hiddenSections[header.key] ? '1px solid #eee' : '1px solid transparent' }}>
                                        <p style={{ color: information?.color ?? '#000', fontWeight: information?.fontWeight ?? '600', fontSize: information?.fontSize ?? 20 }} >{checkTranslation(header?.information?.label)}</p>
                                        <img src="/images/nexts.png" className={" " + (this.state.hiddenSections[header.key] ? '' : 'rotate-90')} height="14px" />
                                    </div>
                                </div>
                            )
                        } else if (header.type == 'StaticText') {
                            return (
                                <div key={header.key} className="col-12  mt-2 text-start StaticText" style={{ marginBottom: information?.marginBottom }}>
                                    <p style={{ color: information?.color, fontWeight: information?.fontWeight, fontSize: information?.fontSize }} >{checkTranslation(header?.information?.label)}</p>

                                </div>
                            )
                        }
                        else if (header.type == 'lineSeperator') {
                            return (
                                <div key={header.key} className="col-12 mb-3 text-start">
                                    <div className="w-100 mt-1" style={{ borderBottom: '1px solid #eee' }}></div>
                                </div>
                            )
                        }
                        else if (header.type == 'PageIndicator') {
                            return (
                                <div key={header.key} className="col-12 mb-2 text-start ">
                                    <button onClick={() => this.props.variables[header.information.function](header.information.inputData)} className="p-0 w-100 flexcb">
                                        <label className={'text-small mrd-1 mld-1  ' + (header.information?.required ? 'required' : '')}>{checkTextTranslation(header.information?.label)}</label>
                                        <img src="/images/nexts.png" height="14px" />
                                    </button>
                                </div>
                            )
                        } else if (header.type == 'FakeCol') {
                            return (
                                <div key={index} className={"p-0 " + this.formColBuilder(header.col) + (index !== header.length - 1 ? ' mb-3' : '')}>
                                </div>
                            )

                        } else if (header.type == 'FormSection') {
                            return (
                                <div className="w-100 mb-3 p-0" key={header.key}>
                                    <Component isInput={true} changeValue={this.changeTab} data={this.state.currentTab} forceInputUpdate={this.props.forceInputUpdate} functionsHandler={this.props.functionsHandler} ref={el => this["component-" + header.key] = el} header={header} setStatus={this.setStatus} variables={this.props.variables} optionsList={this.props.optionsList} width={this.props.width} params={this.state.params} />
                                </div>
                            )
                        } else if (header.type == 'SwitchInput') {
                            if (Component && !header.hideComponent && (header.tab == null || header.tab == this.state.currentTab)) {

                                return (
                                    <div className={"form-label mb-4  d-flex flex-column " + ((this.props.nopadding ? ' p-0 ' : '') + (this.formColBuilder(header.col) + (index !== header.length - 1 ? (' mb-3 ') : '')))} key={header.key} >
                                        <div className={" flexc  " + (header.information?.disabled ? ' disabled ' : '')}>
                                            {/* (header.information.inputClass ?? (this.props.inputClass ? this.props.inputClass : ' default-input-view ')) */}

                                            <Component isInput={true} ref={el => this["component-" + header.key] = el} header={header} data={data} files={files} changeFiles={this.changeFiles} forceInputUpdate={this.props.forceInputUpdate} functionsHandler={this.props.functionsHandler} changeValue={this.changeValue} setStatus={this.setStatus} variables={this.props.variables} fullData={this.state.data} optionsList={this.props.optionsList} width={this.props.width} />
                                            <label className={'  label-text switch-label  mld-3 mrd-1  mb-0 ' + (header.information?.required ? 'required' : '')} >{checkTextTranslation(header.information?.label)}</label>

                                            {header.information?.help && (
                                                <div className='px-1'>
                                                    <HelpButton data={header.information?.help} />
                                                </div>
                                            )}
                                        </div>

                                        {header.information?.hint && (
                                            <div className={" mt-1 mld-2  text-start mt-2 "}>
                                                <p className='text-smaller  ' style={{ color: '#777', cursor: 'default' }} >{checkTextTranslation(header.information?.hint)}</p>
                                            </div>
                                        )}
                                    </div>
                                )
                            }
                        } else if (header.type == 'LicenseInput') {
                            if (Component && !header.hideComponent && (header.tab == null || header.tab == this.state.currentTab)) {

                                return (
                                    <div className={"form-label mb-4  d-flex flex-column " + ((this.props.nopadding ? ' p-0 ' : '') + (this.formColBuilder(header.col)))} key={header.key} >
                                        <div className={" flexc  " + (header.information?.disabled ? ' disabled ' : '')}>

                                            <Component isInput={true} ref={el => this["component-" + header.key] = el} header={header} data={data} files={files} changeFiles={this.changeFiles} forceInputUpdate={this.props.forceInputUpdate} functionsHandler={this.props.functionsHandler} changeValue={this.changeValue} setStatus={this.setStatus} variables={this.props.variables} optionsList={this.props.optionsList} width={this.props.width} params={this.state.params} />

                                        </div>

                                        {header.information?.hint && (
                                            <div className={" mt-1 mld-2  text-start mt-2 "}>
                                                <p className='text-smaller  ' style={{ color: '#777', cursor: 'default' }} >{checkTextTranslation(header.information?.hint)}</p>
                                            </div>
                                        )}
                                    </div>
                                )
                            }
                        } else if (header.type == 'SubformInput' || header.type == 'VariantsInventory' || header.type == 'CombinedInput' || header.type == 'AddressInput') {
                            if (Component && !header.hideComponent && (header.tab == null || header.tab == this.state.currentTab)) {
                                return (
                                    <div className={" w-100   " + ((this.props.nopadding ? ' p-0 ' : '') + (header.type == 'AddressInput' ? " mb-0 " : ' mb-3 ') + (this.formColBuilder(header.col)))} key={header.key}>
                                        <div className={'br-8 ' + (this.state.errors[header.key] ? ' error-input ' : ' ')}>
                                            {header.information?.label && (
                                                <div className={"col-12 flexc form-label text-start p-0"}>
                                                    <label style={{}} className={'label-text   mrd-1 mld-1  ' + (header.information?.required ? 'required' : '')}>{checkTextTranslation(header.information?.label)}</label>
                                                    {header.information?.help && (
                                                        <HelpButton data={header.information?.help} />
                                                    )}
                                                </div>)}
                                            <Component isInput={true} ref={el => this["component-" + header.key] = el} functionsHandler={this.props.functionsHandler} forceInputUpdate={this.props.forceInputUpdate} header={header} data={data} fullData={this.state.data} files={files} changeFiles={this.changeFiles} changeValue={this.changeValue} setStatus={this.setStatus} variables={this.props.variables} optionsList={this.props.optionsList} width={this.props.width} inputClass={this.props.inputClass} extra={this.props.extra} params={this.state.params} />
                                        </div>
                                        {header.information?.hint && (
                                            <div className={" mt-1 mld-2  text-start mt-2 "}>
                                                <p className='text-smaller  ' style={{ color: '#777', cursor: 'default' }} >{checkTextTranslation(header.information?.hint)}</p>
                                            </div>
                                        )}

                                        {this.props.errors && this.props.errors[header.key] && (
                                            <div className={" mt-1 mld-2 text-start "}>
                                                <small style={{ color: '#ee5050' }}>{checkTextTranslation(this.props.errors[header.key])}</small>
                                            </div>
                                        )}

                                        {this.state.errors && this.state.errors[header.key] && (!this.props.errors || !this.props.errors[header.key]) && (
                                            <div className={" mt-1 mld-2 text-start "}>
                                                <small style={{ color: '#ee5050' }}>{checkTextTranslation(this.state.errors[header.key])}</small>
                                            </div>
                                        )}

                                    </div>
                                )
                            }
                        }
                        else {


                            if (Component && !header.hideComponent && (header.tab == null || header.tab == this.state.currentTab)) {


                                return (
                                    <div key={header.key} className={"p-0 " + this.formColBuilder(header.col) + (index !== header.length - 1 ? (' mb-3 ') : '')}>



                                        <div className="row m-0">
                                            {(header.information?.label && !header.information?.withDiscount) && (
                                                <div className={"col-12 flexcb  form-label text-start " + (this.props.nopadding ? 'p-0' : '')}>
                                                    {header.information?.label && (
                                                        <span className='flexc'>

                                                            <p style={{}} className={'label-text   mrd-1 mld-1 ' + (header.information?.required ? ' required ' : '')}>{checkTextTranslation(header.information?.label)}</p>
                                                            {header.information?.help && (

                                                                <HelpButton data={header.information?.help} />
                                                            )}
                                                        </span>
                                                    )}
                                                    {header.showDisabledButton && (
                                                        <SwitchButton id={header.key} isOn={!header.information?.disabled} onChange={this.changeInputDisabledStatus} color={'rgba(52, 199, 89)'} />
                                                    )}
                                                </div>
                                            )}


                                            <div className={"col-12 " + (this.props.nopadding ? 'prd-2 pld-0' : '')} >
                                                <div className={"flexc br-8  " + ((header.information?.disabled ? ' disabled ' : '') + ((header.information?.inputClass) ?? (header.information?.withDiscount ? "" : ((this.props.inputClass) ? this.props.inputClass : 'default-input-view ')) + ' ') + ((this.state.valid[header.key] ? ' valid-input ' : ' ') + (this.state.errors[header.key] ? ' error-input ' : ' ')))} style={{ maxWidth: this.state.width > 500 ? header.maxWidth : null }} >

                                                    {/* {String(header.information?.disabled)} */}
                                                    {header.information?.icon && (
                                                        <img className="mrd-3" src={header.information?.icon} height="25px" alt="icon" />
                                                    )}

                                                    <div className={'w-100 ' + header?.information?.componentClass ?? ''}>
                                                        <Component isInput={true} ref={el => this["component-" + header.key] = el} header={header} functionsHandler={this.props.functionsHandler} forceInputUpdate={this.props.forceInputUpdate} builderHeaders={this.props.builderHeaders} data={data} fullData={this.state.data} params={this.state.params} files={files} changeFiles={this.changeFiles} changeValue={this.changeValue} setStatus={this.setStatus} variables={this.props.variables} optionsList={this.props.optionsList} width={this.props.width} headers={this.props.headers} colors={this.props.colors} inputClass={this.props.inputClass} extra={this.props.extra} />
                                                    </div>


                                                </div>
                                            </div>



                                            {header.information?.hint && (

                                                <div className={" mt-0 pld-2 text-start mt-2 w-100" + (this.props.nopadding ? '' : ' px-3 ')}>
                                                    <p className='text-smaller text-semibold ' style={{ color: '#777', cursor: 'default' }} >{checkTextTranslation(header.information?.hint)}</p>
                                                </div>
                                            )}

                                            {this.props.errors && this.props.errors[header.key] && (
                                                <div className={" mt-1 mld-2 text-start w-100 " + (this.props.nopadding ? '' : ' px-3 ')}>
                                                    <small style={{ color: '#ee5050' }}>{checkTextTranslation(this.props.errors[header.key])}</small>
                                                </div>
                                            )}

                                            {this.state.errors && this.state.errors[header.key] && (!this.props.errors || !this.props.errors[header.key]) && (
                                                <div className={" mt-1 mld-2 text-start w-100 " + (this.props.nopadding ? '' : ' px-3 ')}>
                                                    <small style={{ color: '#ee5050' }}>{checkTextTranslation(this.state.errors[header.key])}</small>
                                                </div>
                                            )}

                                        </div>
                                    </div>
                                )
                            }

                        }


                    })}

                    {this.props.errors && (typeof this.props.errors == 'string') && (
                        <div className="col-12 text-start">
                            <small style={{ color: '#ee5050' }}>{checkTextTranslation(this.props.errors)}</small>
                        </div>
                    )}



                    {/* <ButtonAnimated
            iconwidth='24px'
            onClick={this.addClicked}
            title='New Record'
            icon='/assets/icons/plus-white.svg'
            bg='linear-gradient(to right, #5856D6, #7D7AFF)'
        /> */}

                </div>

            </section>
        )
    }

    render() {


        if (this.state.show && this.state.headers) {
            if (!this.state.currentPage || !this.state.currentPage.sections) {
                return (
                    <div className={'w-100  ' + (this.props.nopadding ? ' p-0 ' : '')} style={this.props.sectionStyle ?? { background: '#fff', boxShadow: '0px 0px 20px #00000005', borderRadius: 10, padding: '10px 0px', marginBottom: this.props.marginBottom != null ? this.props.marginBottom : 30, }}>
                        {this.renderSection(this.state.headers)}
                    </div>
                )
            } else {
                return (
                    <div className='w-100'>

                        {this.state.currentPage.sections.map((section, index) => {

                            let headers = this.state.headers.filter((a) => (a.section == section.key && !a.hideComponent))
                            if (headers && headers.length > 0) {
                                return (
                                    <div style={this.props.sectionStyle ?? { background: '#fff', boxShadow: '0px 0px 20px #00000005', borderRadius: 10, padding: '10px 0px', marginBottom: 30, }}>
                                        {section?.information?.label && (
                                            <div className='px-3 mb-3 pb-2' style={{ borderBottom: '1px solid #eee' }}>
                                                <p className='text-bold text-semibig px-1'>{checkTranslation(section?.information?.label)}</p>
                                            </div>
                                        )}
                                        <div className='px-1'>
                                            {this.renderSection(headers)}
                                        </div>
                                    </div>
                                )
                            }
                        })}

                    </div>
                )
            }

        } else {
            return (<div></div>)
        }
    }
}

export default FormViewer;